module.exports = __webpack_public_path__ + "static/image/history/m/202404@3x.ver2_0_2.png?eec6c563";